import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import RequestMessages from '~/components/shared/RequestMessages';
import ServiceRequestContext from '../context';
const MessagesTab = ({focused}) => {
  const {replacement, rob} = useContext(ServiceRequestContext);
  return (
    <RequestMessages
      focused={focused}
      request_id={replacement?.request_id}
      overview={replacement}
      lessor_status={rob?.rob_status}
      cancelled_read_only
      require_request_id
    />
  );
};
MessagesTab.propTypes = {focused: PropTypes.any};
export default MessagesTab;
